<template>
	<section>
		<el-form :model="formData" label-width="90px" ref="formRef" :rules="rules" label-position="right"
			style="width: 100%;padding-right:30px;box-sizing:border-box">
			<el-form-item label="文件名" prop="name" v-if="status=='edit'">
				<el-input placeholder="请输入文件名" v-model="formData.name"></el-input>
			</el-form-item>

			<el-form-item v-if="status=='add'" label="目录" prop="catalog_id">
				<select-catalog v-model="formData.catalog_ids" />
			</el-form-item>
			<el-form-item v-else label="目录" prop="catalog_id">
				<select-catalog :multiple="false" v-model="formData.catalog_id" />
			</el-form-item>
			<el-form-item label="学年" prop="school_year">
				<el-select v-model="formData.school_year" placeholder="学年" @change="onSchoolYear">
					<el-option v-for="item in schoolYearList" :key="item" :label="item+'学年'" :value="item">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="学期" prop="term_no">
				<el-select placeholder="学期" v-model="formData.term_no" @change="onTermNo">
					<el-option label="全学年" value="00" />
					<el-option label="第一学期" value="01" />
					<el-option label="第二学期" value="02" />
				</el-select>
			</el-form-item>
			<el-form-item label="班级" prop="class_id">
				<el-select placeholder="班级" v-model="formData.class_id" filterable>
					<el-option :label="one.name" :value="one.id" v-for="(one,index) in classList" :key="index">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="上传文件" v-if="status=='add'">
				<upload-file @complete="submit" ref="uploadFile" />
			</el-form-item>
		</el-form>
		<div :class="status=='add'?'footer':'form-footer'">
			<el-button type="primary" :loading="loading" @click="status=='add'?commit():edit()">提交</el-button>
			<el-button :loading="loading" @click="$emit('cancel')">取消</el-button>
		</div>
	</section>
</template>
<script>
	// 关于资料库文件上传和修改信息的逻辑
	import { mapState } from 'vuex'
	import { schoolClass, file, oa_catalog } from '@/api/server'
	import select from '../../components/products/select.vue'
	import SelectCatalog from './select-catalog'
	import UploadFile from '@/components/upload-file.vue'
	export default {
		components: { select, SelectCatalog,UploadFile },
		props: ['defaultData', 'catalogId'],
		data() {
			return {
		
				status: this.defaultData ? 'edit' : 'add',
				formData: this.defaultData || {
					school_year: null,
					catalog_ids: [this.catalogId],
					class_id: null,
					term_no: '00'
				},
				tree:[],
				classList: [],
				rules: {
					name: [{ required: true, message: "请输入文件名称", trigger: "blur" }],
					school_year: [{ required: true, message: "请选择学年", trigger: "change" }],
					// class_id: [{ required: true, message: "请班级", trigger: "change" }],
					term_no: [{ required: true, message: "请选择学期", trigger: "change" }],
				},
				loading: false,
		
			}
		},
		computed: {
			...mapState('school', ['schoolYearList', 'schoolDate'])
		},
		methods: {
			uploadTerm(data) {
				let param = { id: this.selectId, term_id: this.editTerm.data.term_id };
				this.editTerm.loading = true
				oa_catalog.edit(param).then(res => {
					this.editTerm.loading = false
					if (res.data) {
						this.$message({ message: "修改学期成功！", type: "success" });
						this.editTerm.visible = false;
						this.selectId = null;
						this.getCatalogList();
					} else {
						this.$message({ message: res.data.msg, type: "error" });
					}
				});
			},
			onSchoolYear(e) {
				this.formData.school_year = e
				this.formData.class_id = null
				this.getClassList(e)
				if (e > this.schoolDate.year) {
					this.formData.term_no = '01'
				} else if (e < this.schoolDate.year) {
					this.formData.term_no = '02'
				} else {
					this.formData.term_no = '0'+this.schoolDate.term
				}
			},
			onTermNo(e) {
				console.log(e)
				this.formData.term_no = e
			},
			getClassList(schoolYear) {
				schoolClass.getSimpleClassList({ school_year: schoolYear }).then(res => {
					if (res.data) {
						this.classList = res.data.map(r => {
							return {
								id: r.class_id,
								grade_id: r.grade_id,
								name: r.grade + r.name
							}
						})
					}
				})
			},

			commit() {
				// if (this.fileList.length <= 0) {
				// 	this.$message.warning("请选择文件上传")
				// 	return
				// }
				this.$refs.formRef.validate(valid => {
					if (!valid) {
						this.$message.error('* 请填写所有必填项')
						return
					} else {
						this.loading = true
						this.$refs.uploadFile.submit()
					}
				})
			},
			submit(e) {
				console.log('===submit==>',e)
				// 做一个数据拷贝以免影响
				let params = Object.assign({}, this.formData)
				params.attachment=e
				params.term_no = params.school_year + params.term_no
				oa_catalog.upload(params).then(res => {
					this.loading = false
					if (res.data) {
						this.$message.success('添加成功')
						this.$emit('success')
					}
				})
			},
			edit() {
				this.$refs.formRef.validate(valid => {
					if (!valid) {
						this.$message.error('* 请填写所有必填项')
						return
					} else {
						this.loading = true
						let params = Object.assign({}, this.formData)
						params.term_no = params.school_year + params.term_no
						oa_catalog.edit(params).then(res => {
							this.loading = false
							if (res.data) {
								this.$message.success('修改成功')
								this.$emit('success')
							}
						})

					}
				})
			},
			


		},
		mounted() {

			if (!this.defaultData || !this.defaultData.school_year) {
				this.formData.school_year = this.schoolDate.year
				this.formData.term_no = (this.schoolDate.term_no + '').substring(4)
			}
			this.getClassList(this.formData.school_year)
		}
	}
</script>
<style lang="scss" scoped>
	.el-select {
		width: 100%;
	}
	.footer {
		width: 100%;
		position: absolute;
		top: 0;
		text-align: right;
		padding-right: 20px;
		margin-top: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/views/oa_catalog/add-form.vue